import React from 'react';
import classNames from 'classnames';
import NumberFormat from 'react-number-format';

const Currency: React.FC<{ value: number, className?: any }> = ({ value = 0, className }) => (
    <NumberFormat 
        className={classNames('', className)}
        value={value} 
        displayType={'text'} 
        thousandSeparator='.'
        decimalSeparator=','
        prefix={'$'} 
    />
);

export default Currency;